import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// a basic in memory queue with an asynchronous api
var MemoryQueueAsync =
/*#__PURE__*/
function () {
  function MemoryQueueAsync() {
    _classCallCheck(this, MemoryQueueAsync);

    this.queue = [];
  }

  _createClass(MemoryQueueAsync, [{
    key: "enqueue",
    value: function () {
      var _enqueue = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this$queue;

        var _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$queue = this.queue).push.apply(_this$queue, _args));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function enqueue() {
        return _enqueue.apply(this, arguments);
      }

      return enqueue;
    }()
  }, {
    key: "dequeue",
    value: function () {
      var _dequeue = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var limit,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                limit = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;

                if (limit) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", this.queue.splice(0, this.queue.length));

              case 3:
                if (!(typeof limit !== 'number')) {
                  _context2.next = 5;
                  break;
                }

                throw new Error('queue.dequeue: first argument must be a number');

              case 5:
                if (!(limit < 0)) {
                  _context2.next = 7;
                  break;
                }

                throw new Error('queue.dequeue: cannot dequeue a negative number of items');

              case 7:
                return _context2.abrupt("return", this.queue.splice(0, limit));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function dequeue() {
        return _dequeue.apply(this, arguments);
      }

      return dequeue;
    }()
  }, {
    key: "toArray",
    value: function () {
      var _toArray = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.queue.slice());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function toArray() {
        return _toArray.apply(this, arguments);
      }

      return toArray;
    }()
  }]);

  return MemoryQueueAsync;
}();

export { MemoryQueueAsync as default };